import React from 'react';
import { useSelector } from 'react-redux';
import type { RouteComponentProps } from 'react-router';
import { withRouter } from 'react-router';

import { Brand } from '@swf/core/enums';
import { select } from '@swf/core/store';

import Default from './components/Default/Default';
import FoxBet from './components/FoxBet/FoxBet';
import SportsMaintenance from './components/SportsMaintenance/SportsMaintenance';

const ServiceUnavailable: React.FC<RouteComponentProps> = ({ staticContext }) => {
  const brand = useSelector(select.site.getBrand);

  if (staticContext) {
    staticContext.statusCode = 503;
  }

  if (brand === Brand.BetStars) {
    return <SportsMaintenance />;
  }

  if (brand === Brand.FoxBet) {
    return <FoxBet />;
  }

  return <Default />;
};

export default withRouter(ServiceUnavailable);
